import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProyectosService } from '../../../services/proyectos.service';

@Component({
  selector: 'app-alto-piura',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './alto-piura.html',
  styleUrl: './alto-piura.css'
})
export class AltoPiuraComponent implements OnInit {
  proyectosRecomendados: any[] = [];

  constructor(private proyectosService: ProyectosService) {}

  ngOnInit() {
    this.proyectosRecomendados = this.proyectosService.getProyectosAleatorios('/proyectos/alto-piura');
  }
}
